<template>
  <div>
    <h2 class="title is-4 is-main-title">Ligações</h2>

    <p><a href="http://www.cehr.ft.lisboa.ucp.pt" target="_blank"
    >Centro de Estudos de História Religiosa (CEHR-UCP)</a></p>

    <p><a href="https://gulbenkian.pt/" target="_blank"
    >Fundação Calouste Gulbenkian (Entidade Financiadora)</a></p>

    <p><a href="https://dominicanos.pt/" target="_blank"
    >Página da Ordem dos Pregadores da Província de Portugal e Vicariato de Angola.</a></p>
  </div>
</template>

<script>
export default {
  name: 'Links',
}
</script>

<style scoped>
.is-main-title{
  margin: 0.55em;
}

.is-main-content p{
  font-size: 14px;
  text-align: justify;
  margin: 1em;
  line-height: 1.4;
}
</style>

